import { useState, useEffect, useContext } from "react";
import Profile from "./profile/Profile";
import { useNavigate, useParams  } from "react-router-dom";
import verifyMyCandidateResponse from "../../apis/recruiters/verifyMyCandidateAccess";
import {jwtDecode}  from "jwt-decode";
import { DateTime } from "luxon";
import { UserTypeContext } from "../../AppRoute";
const AdminProfile = (props) => {
  const { userType} = useContext(UserTypeContext);
  const history = useNavigate();
  const params=useParams()
  const [userId, setuserId] = useState("");
  const token = localStorage.getItem("token");

  const getRecruiterResponse = async () => {
    try {
      let payload = {
        "candidateid": params.id,
        "id": userId
      }
      let isRecruiterHasAccessResponse = await verifyMyCandidateResponse(payload)
      if (!isRecruiterHasAccessResponse.data.access) {
        history("/");
      }
    } catch (error) {
      history("/");
    }
  };

  useEffect(() => {
    tokenExpireVerification();
  }, []);

  const tokenExpireVerification = () => {
    try {
      const decodedJwt = jwtDecode (token);

      if (decodedJwt) {
        if (decodedJwt.exp < DateTime.now().toUnixInteger()) {
          localStorage.clear();
          history("/")

        } else {
          setuserId(decodedJwt.id);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (userId) {
      getRecruiterResponse();
    }
  }, [userId]);
  return (
    <>
      {userType === "Admin" || userType === "Recruiter" || userType=== "Recruitment Leader"  || userType === "Organization Admin" || userType === "MIS Operator" || userType=== "Team Leader" ? (
        <div>
          <Profile candidateId={params.id} recruitmentpartnerId ={params.recruitmentpartnerId}  testAccess={false} isShare={false} />
        </div>
      ) : (<>
        <div className="row padding_80 text-center">
          <p className="fs-semi-bold fs-40 f-color">
            You Are Not Authorized To Visit This Page
          </p>
        </div>
      </>)}
    </>
  );
};

export default AdminProfile;

